import apiClient from '../utils/apiClient';
import getPortalKey from '../utils/getPortalKey';
import getSpaId from '../utils/getSpaId';

import { AxiosError } from 'axios';
import { FormDataType } from '../contexts/FormProvider';

const spaId = getSpaId() || '';
const portalKey = getPortalKey() || 'NULL';

interface ServerRequest {
  config: string;
  spname: string;
  q: string;
}
export interface ServerResponse {
  ReturnCode: number;
  ErrorMessage: string;
  Response: string;
}
export enum APIError {
  Invalid = 1,
  NotFound = 2,
  AlreadyRedeemed = 3,
  BadRequest = 400,
  InternalServerError = 500,
}

const sendRequest = async (body: ServerRequest) => {
  try {
    const res = await apiClient.post('/data', body);
    if (res.data.ReturnCode === 0) {
      const customerData = JSON.parse(res.data.Response);
      return customerData;
    } else {
      // Server returns 200, but request failed for some reason so we handle errors on our side
      throw res.data;
    }
  } catch (error) {
    let mappedError = error;

    // Server errors
    if ((error as AxiosError).response) {
      const serverError = error as AxiosError;
      // Bad request or server error
      if (serverError.response?.status === 400 || serverError.response?.status === 500) {
        mappedError = serverError.response?.data;
      } else {
        // All other errors treated as System Outage (Server not found, method not allowed, CORS issues)
        mappedError = {
          ReturnCode: null,
          ErrorMessage: 'System outage',
          Response: null,
        };
      }
    }

    throw Error(JSON.stringify(mappedError));
  }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const validateProviderForm = async (formFields: any) => {
  const BreachOrComplaintOrFha = formFields.BreachOrComplaintOrFha || 'NULL';

  const query = `portal-key=${portalKey}&complaint-type=${BreachOrComplaintOrFha}`;

  const requestBody: ServerRequest = {
    config: spaId,
    spname: 'validate-policy',
    q: query,
  };

  return sendRequest(requestBody);
};

const validateConsentForm = (formFields: FormDataType) => {
  const policyNumber = formFields.policyNumber || 'NULL';
  const policyOrClaim = formFields.policyOrClaim || 'NULL';

  const query = `portal-key=${portalKey}&policy-no=${policyNumber}&rego-no=${policyOrClaim}`;

  const requestBody: ServerRequest = {
    config: spaId,
    spname: 'register-complaint',
    q: query,
  };

  return sendRequest(requestBody);
};

export { validateProviderForm, validateConsentForm };
